import axios from './config';
import _this from '../main';
import { localStorage } from '../util/index';

const request = async (method, url, params) => {
  // console.log(url, '1', localStorage.get(`${process.env.NODE_ENV}-token`))
  // if (localStorage.get(`${process.env.NODE_ENV}-token`) && url.indexOf('circle/login') === -1) {
  //   // setTimeout(() => axios[method](url, params), 500);
  //   console.log(url, '2')
  //   await axios.post(url).then(({ data: { token } }) => {
  //     _this.globalData.token = token;
  //     localStorage.set(`${process.env.NODE_ENV}-token`, token);
  //   });
  //   console.log(url, '3')
  // }
  // console.log(url, '4')
  return axios[method](url, params).then(({ data }) => data);
};

const Rest = {};
['get', 'post', 'put'].forEach((method) => {
  Rest[method] = (url, params) => request(method, url, params);
});

export default Rest;
